<template>
  <div>
    <v-navigation-drawer
      v-model="panel.activated"
      :width="$isMobile ? '100%' : '60%'"
      right
      fixed
      :permanent="panel.activated"
      hide-overlay
      class="z-index--100">
      <div class="ma-3">
        <div class="d-flex justify-space-between">
          <div class="d-flex">
            <v-btn
              dark
              fab
              x-small
              outlined
              color="primary"
              class="mr-3"
              @click="closeDialog"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <div
              class="subtitle-1 primary--text mr-3">
              Orden de compra: {{ detail.uuid }}
            </div>
          </div>
          <div>
            <v-tooltip
            v-if="isUserProvider && purchaseOrderPermissions['print-purchase-order']"
            left>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  fab
                  color="primary"
                  x-small
                  depressed
                  @click="printOrder"
                >
                  <v-icon
                    small
                  >
                    mdi-printer
                  </v-icon>
                </v-btn>
              </template>
              <span>Imprimir orden de compras</span>
            </v-tooltip>
            <v-tooltip
            v-if="purchaseOrderPermissions['send-purchase-order-via-email']"
            left>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  fab
                  color="primary"
                  x-small
                  depressed
                  @click="openSendByEmailDialog"
                >
                  <v-icon
                    small
                  >
                    mdi-email
                  </v-icon>
                </v-btn>
              </template>
              <span>Enviar orden de compra por mail</span>
            </v-tooltip>
            <v-tooltip
              v-if="purchaseOrderPermissions['copy-purchase-order-link']"
              left>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  fab
                  color="primary"
                  x-small
                  depressed
                  v-clipboard:copy="copyToLink"
                  v-clipboard:success="onCopy"
                >
                  <v-icon
                    small
                  >
                    mdi-link-variant
                  </v-icon>
                </v-btn>
              </template>
              <span>Copy link</span>
            </v-tooltip>
            <v-tooltip v-if="notificationOrdersPermissions['resent-purchase-order-email-to-provider'] && (detail.status === 'sent' && detail.isRead === false)"
            left>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  fab
                  color="secondary"
                  x-small
                  depressed
                  @click="reSentPurchaseOrderEmail">
                  <v-icon small>mdi-send</v-icon>
                </v-btn>
              </template>
              <span>Reenviar email de nueva orden de compra.</span>
            </v-tooltip>
          </div>
        </div>
        <v-container ref="order-detail">
          <v-row>
            <v-col md="12">
              <v-card outlined>
                <v-row>
                  <v-col md="6" cols="12">
                    <div class="subtitle-2 mb-2 px-2">
                      <div v-if="$is() === 'provider'">
                        <div>
                          Restaurante:
                        </div>
                        <div class="grey--text">
                          {{ order.restaurant }}
                        </div>
                      </div>
                      <div v-else>
                        <div>
                          Proveedor:
                        </div>
                        <div class="grey--text">
                          {{ detail.provider ? detail.provider.name : '' }}
                        </div>
                      </div>
                    </div>
                    <!-- <div class="subtitle-2 mb-2 px-2">
                      <div>
                        Nombre del emisor:
                      </div>
                      <div class="grey--text">
                        {{ detail.author && detail.author.email ? detail.author.email : '' }}
                      </div>
                    </div> -->
                    <div class="subtitle-2 mb-2 px-2">
                      <div>
                        Area:
                      </div>
                      <div class="grey--text">
                        {{ detail.area && detail.area.name ? detail.area.name : 'No se encontró el area'}}
                      </div>
                    </div>
                    <div class="subtitle-2 mb-2 px-2">
                      <div>
                        {{ displayModificationText(detail) }}
                      </div>
                      <div class="grey--text">
                        {{ getLastModificationPerson(detail) }}
                      </div>
                    </div>
                    <div class="subtitle-2 mb-2 px-2" v-if="detail.status === 'canceled' && detail.cancelationMotive">
                      <div>
                        Motivo de cancelación:
                      </div>
                      <div class="grey--text">
                        {{ findCancelationMotive(detail.cancelationMotive) }}
                      </div>
                    </div>
                    <div class="subtitle-2 mb-2 px-2">
                      <div>
                        Estatus:
                      </div>
                      <div :class="`${statusColors(detail.status)}--text`">
                        {{ statusNames(detail.status) }}
                      </div>
                    </div>
                  </v-col>
                  <v-col md="3" cols="12">
                    <div v-if="$is() === 'provider'" class="subtitle-2 mb-2 px-2">
                      <div>
                        RFC:
                      </div>
                      <div v-if="detail.restaurant && detail.restaurant.taxInformation" class="grey--text">
                        {{ detail.restaurant.taxInformation.taxId }}
                      </div>
                    </div>
                    <div class="subtitle-2 mb-2 px-2">
                      <div>
                        Fecha de emisión:
                      </div>
                      <div class="grey--text">
                        {{ convertToDateString(detail.createdAt) }}
                      </div>
                    </div>
                    <div
                      v-if="$is() !== 'provider'"
                      class="subtitle-2 mb-2 pa-2">
                      <div>
                        Total de la compra (con impuestos):
                      </div>
                      <div class="grey--text">
                        ${{ total | toFix2 | numberWithComma }}
                      </div>
                    </div>
                    <div class="subtitle-2 mb-2 px-2">
                      <v-tooltip class="style-tool" left>
                        <template v-slot:activator="{ on, attrs }">
                          <span
                            v-bind="attrs"
                            v-on="on"
                            class="font-weight-bold"
                          >
                            <v-icon small>mdi-information</v-icon>
                            Histórico por estatus
                          </span>
                        </template>
                        <v-timeline>
                          <v-timeline-item
                            small
                            v-for="(item, index) in detail.statusChanges"
                            :key="`item-${index}`"
                          >
                            <strong>{{ statusNames(item.name) }}</strong>
                            <div style="font-size: 10px;">
                              {{ item.createdAt | toDateTime }}
                            </div>
                          </v-timeline-item>
                        </v-timeline>
                      </v-tooltip>
                    </div>
                    <!-- <div
                      v-if="detail.commission > 0
                        && ['manager', 'stockmanager'].includes($is())"
                      class="subtitle-2 mb-2 px-2">
                      <div>
                        Cargo por servicio:
                        <v-tooltip
                          left
                          max-width="300">
                          <template v-slot:activator="{ on }">
                            <v-btn x-small icon v-on="on">
                              <v-icon color="primary">mdi-information</v-icon>
                            </v-btn>
                          </template>
                          <span>
                            El cargo por servicio se factura de manera independiente.<br>
                            La factura del proveedor se emitirá por ${{ total | toFix2 | numberWithComma }}.
                          </span>
                        </v-tooltip>
                      </div>
                      <div class="grey--text">
                        ${{ detail.commission | toFix2 | numberWithComma }}
                      </div>
                    </div> -->
                  </v-col>
                  <v-col v-if="$is() === 'provider'" md="3" cols="12">
                    <div class="subtitle-2 mb-2 px-2">
                      <div>
                        Nombre fiscal:
                      </div>
                      <div v-if="detail.restaurant && detail.restaurant.taxInformation" class="grey--text">
                        {{ detail.restaurant.taxInformation.taxName }}
                      </div>
                    </div>
                  </v-col>
                </v-row>
                <div v-if="$is() === 'provider'" class="d-flex justify-space-between px-2 subtitle-2">
                  <span
                    class="font-weight-bold mb-2">
                    Subtotal:
                  </span>
                  <span class="title">${{ subtotal | toFix2 | numberWithComma }}</span>
                </div>
                <div v-if="$is() === 'provider'" class="d-flex justify-space-between px-2 subtitle-2">
                  <span
                    class="font-weight-bold mb-2">
                    IVA:
                  </span>
                  <span class="title">${{ iva | toFix2 | numberWithComma }}</span>
                </div>
                <div v-if="$is() === 'provider'" class="d-flex justify-space-between px-2 subtitle-2">
                  <span
                    class="font-weight-bold mb-2">
                    IEPS:
                  </span>
                  <span class="title">${{ ieps | toFix2 | numberWithComma }}</span>
                </div>
                <div class="d-flex justify-space-between px-2 subtitle-2">
                  <span
                    v-if="$is() === 'provider'"
                    class="font-weight-bold mb-2">
                    Total de la orden (con impuestos):
                  </span>
                  <span
                    v-else
                    class="font-weight-bold mb-2">
                    Total a pagar:
                  </span>
                  <span class="title">${{ totalToPay | toFix2 | numberWithComma }}</span>
                </div>
              </v-card>

              <v-btn
                v-on:click="onDeliverDialog"
                block
                color="success"
                class="my-3"
                v-if="$isMobile && ['invoiced'].includes(detail.status) && ['provider'].includes($is())">
                Entregar mercancía
              </v-btn>

              <v-card outlined class="mt-5">
                <div class="d-flex justify-space-between px-2 subtitle-2">
                  <div class="subtitle-1 px-2">
                  Total de facturas:
                </div>
                  <span class="title">${{ totalInvoices | toFix2 | numberWithComma }}</span>
                </div>
                <div class="pa-2">
                  <ul v-if="countryRestaurant === 'MX'">
                    <li v-for="(item, index) in detail.invoices" :key="item._id">
                      <v-divider v-if="index > 0"/>
                      <div class="d-flex justify-space-between align-center">
                        <div>
                          <v-menu offset-y right>
                            <template v-slot:activator="{ on }">
                              <v-btn
                                x-large
                                v-on="on"
                                plain
                                color="primary"
                                class="pa-0"
                              >
                                {{ item.uuid }}
                              </v-btn>
                            </template>
                            <v-list>
                              <v-list-item @click="viewInvoice(item)">
                                <v-list-item-title>
                                  Visualizar factura
                                </v-list-item-title>
                              </v-list-item>
                              <v-list-item @click="downloadInvoice(item)">
                                <v-list-item-title>
                                  Descargar factura
                                </v-list-item-title>
                              </v-list-item>
                              <v-list-item v-if="item.status === 'active' && ['facturapi', 'xml'].includes(item.source) && ['invoiced', 'received', 'pending_payment', 'paid'].includes(order.status)" @click="checkStatusInvoice(item)">
                                <v-list-item-title>
                                  Verificar estatus en el SAT
                                </v-list-item-title>
                              </v-list-item>
                              <v-list-item :href="downloadOrderInvoice(item)" v-if="['invoiced', 'received', 'pending-payment', 'paid'].includes(order.status)">
                                <v-list-item-title>
                                  Imprimir factura (PDF)
                                </v-list-item-title>
                              </v-list-item>
                            </v-list>
                          </v-menu>
                          <div class="caption">
                            Folio: <span class="primary--text">{{ item.folio }}</span>
                          </div>
                          <div :class="[`${invoiceStatuses[item.status].color}--text`, 'caption']">
                            {{ invoiceStatuses[item.status].text }}
                          </div>
                          <div class="caption">
                            Origen: <span class="primary--text"> {{ invoiceSource[item.source] }}</span>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </v-card>

              <v-card outlined class="mt-5" v-if="countryRestaurant === 'MX'">
                <div class="subtitle-1 px-2">
                  Nota de crédito:
                </div>
                <div class="pa-2">
                  <ul>
                    <li v-for="(item, index) in detail.creditNotes" :key="item._id">
                      <v-divider v-if="index > 0"/>
                      <div class="d-flex justify-space-between align-center pa-2">
                        <div>
                          <div>
                            <a class="primary--text" href="#" @click.prevent="viewCreditNote(item)">{{ item.uuid }}</a>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </v-card>
              <v-card outlined class="mt-5"  v-if="['created'].includes(detail.status)">
                <div class="d-flex justify-space-between">
                  <div class="subtitle-1 ma-1">
                    Direcciones de entrega de mercancía:
                  </div>
                  <div class="ma-1">
                     <v-btn
                      fab
                      style="height: 25px; min-width: 25px;"
                      depressed
                      color="primary"
                      @click="deliveryDialog=true">
                      <v-icon size="15">mdi-plus</v-icon>
                    </v-btn>
                  </div>
                </div>
                <div class="pa-2">
                  <v-list two-line>
                    <v-list-item-group
                      v-model="selected"
                      @change="changeDeliveryAddress"
                    >
                      <template v-for="(item, index) in restaurant.deliveryAddresses">
                        <v-list-item :key="item.title">
                          <template v-slot:default="{ active }">
                            <v-list-item-avatar size="25">
                              <v-icon v-if="!active">
                                mdi-checkbox-blank-circle-outline
                              </v-icon>
                              <v-icon v-else>
                                mdi-checkbox-marked-circle
                              </v-icon>
                            </v-list-item-avatar>

                            <v-list-item-content>
                              <v-list-item-title v-text="item.address"></v-list-item-title>
                              <v-list-item-subtitle v-text="item.schedule"></v-list-item-subtitle>
                              <v-list-item-subtitle v-text="item.receiver"></v-list-item-subtitle>
                               <v-list-item-subtitle v-text="item.comments"></v-list-item-subtitle>
                            </v-list-item-content>
                          </template>
                        </v-list-item>

                        <v-divider
                          v-if="index < items.length - 1"
                          :key="index"
                        ></v-divider>
                      </template>
                    </v-list-item-group>
                  </v-list>
                </div>
              </v-card>
              <v-card outlined class="mt-5"  v-if="!['created'].includes(detail.status)">
                <div class="subtitle-1 px-2">
                  Dirección de entrega de mercancía:
                </div>
                <div class="pa-2">
                  <p class="mb-0 font-weight-black">
                    {{ detail.deliveryAddress ? detail.deliveryAddress.address : '' }}
                  </p>
                  <p class="mb-0 font-weight-thin">
                    {{ detail.deliveryAddress ? detail.deliveryAddress.schedule : '' }}
                  </p>
                  <p class="mb-0 font-weight-thin">
                    {{ detail.deliveryAddress ? detail.deliveryAddress.receiver : '' }}
                  </p>
                  <p class="mb-0 font-weight-thin">
                    {{ detail.deliveryAddress ? detail.deliveryAddress.comments : '' }}
                  </p>
                </div>
              </v-card>
            </v-col>

            <v-col md="12" v-if="!['created'].includes(detail.status) && ['provider', 'provider-buyer', 'manager', 'buyer', 'stockmanager'].includes($is())">
              <v-card outlined class="pa-3">
                <div class="body-2 mb-3">
                  Notas del restaurante:
                </div>
                <div>
                  {{ detail.notes }}
                </div>
              </v-card>
            </v-col>

            <v-col md="12" v-if="['invoiced',
              'received',
              'pending_payment',
              'paid', 'invalid'].includes(detail.status)
              && ['provider',
              'provider-buyer',
              'manager',
              'buyer',
              'stockmanager'].includes($is())
              && tableOriginalProducts.total > 0">
              <v-card outlined>
                <div class="d-flex justify-end">
                  <div class="font-weight-bold ma-2">
                    Cantidad de artículos:
                    <span v-bind:class="{'red--text': quantityOriginalProducts > 0 && quantityOriginalProducts !== totalProducts}">
                      {{ quantityOriginalProducts }}
                    </span>
                  </div>
                  <div class="font-weight-bold ma-2">
                    Total de compra:
                    <span v-bind:class="{'red--text': totalOriginalProducts > 0 && totalOriginalProducts !== total}">
                      ${{ totalOriginalProducts | toFix2 | numberWithComma }}
                    </span>
                  </div>
                </div>
                <v-list>
                  <v-list-group
                    v-for="item in items"
                    :key="item.title"
                    v-model="item.active"
                    no-action
                  >
                    <template v-slot:activator>
                      <v-list-item-content>
                        <v-list-item-title v-text="item.title"></v-list-item-title>
                      </v-list-item-content>
                    </template>

                    <v-list-item>
                      <v-list-item-content>
                        <v-data-table
                          :loading-text="tableOriginalProducts.title"
                          :server-items-length="tableOriginalProducts.total"
                          :loading="tableOriginalProducts.loading"
                          :headers="getHeaders"
                          :items="tableOriginalProducts.data"
                          :options="tableOriginalProducts.options"
                          sort-by="product"
                          :height="tableOriginalProducts.data.length >= 10 ? 600 : 400"
                          hide-default-footer>
                          <template v-slot:item.amount="{ item }">
                            <div class="text-right">
                              ${{ (item.amount || 0) | toFixNumber(2) | numberWithComma }}
                            </div>
                          </template>
                          <template v-slot:item.unit.name="{ item }">
                            <div>
                              {{ item.unit.name }}
                            </div>
                            <div v-if="item.unit._id !== item.contentUnit" class="grey--text">
                              de {{ item.contentQuantity }} {{ getUnitName(item.contentUnit) }} c/u
                            </div>
                          </template>
                          <template v-slot:item.amountWithTax="{ item }">
                            <div class="text-right">
                              ${{ (item.amountWithTax || 0) | toFixNumber(2) | numberWithComma }}
                            </div>
                          </template>
                          <template v-slot:item.quantityConfirmed="{ item }">
                            <div class="text-right">
                              {{ item.quantityConfirmed }}
                            </div>
                          </template>
                          <template
                            v-slot:item.quantityReceived="{ item }"
                            v-if="(detail.status === 'invoiced' || (detail.status === 'confirmed' && (detail.provider.receiveWithoutInvoice || countryRestaurant !== 'MX'))) && ['manager', 'stockmanager'].includes($is())">
                            {{ item.quantityReceived }}
                          </template>
                          <template v-slot:item.totalWithTax="{ item }">
                            ${{ (item.totalWithTax || 0) | toFixNumber(2) | numberWithComma }}
                          </template>
                          <template v-slot:item.total="{ item }">
                            ${{ (item.total || 0) | toFixNumber(2) | numberWithComma }}
                          </template>
                        </v-data-table>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-group>
                </v-list>
              </v-card>
            </v-col>

            <v-col md="12">
              <div v-if="['sent', 'confirmed'].includes(detail.status) && $is() === 'provider'">
                <div class="py-2">
                  <v-alert dense type="info">
                    Asegurate de agregar servicios si son necesarios, una vez confirmada la orden de compra ya no podrás agregarlos.
                  </v-alert>
                  <v-alert v-if="actualDate" dense type="warning">
                    <span>Es posible que tu pago sufra un <b>retraso</b> debido a que estás facturando mismo día en que se pagan a proveedores por parte de Eato.</span>
                  </v-alert>
                </div>
                <v-tabs v-model="tab">
                  <v-tab
                    v-if="purchaseOrderPermissions['change-purchase-order-add-product']"
                    key="Productos">
                    Productos
                  </v-tab>
                  <v-tab
                    v-if="purchaseOrderPermissions['change-purchase-order-add-service']"
                    key="Servicios">
                    Servicios
                  </v-tab>
                </v-tabs>
                <v-tabs-items v-model="tab">
                  <v-tab-item key="Productos">
                    <div class="d-flex justify-end">
                      <div class="font-weight-bold mb-2">
                        Cantidad de artículos: {{ totalProducts }}
                      </div>
                    </div>
                    <v-data-table
                      :loading-text="table.title"
                      :server-items-length="table.total"
                      :loading="table.loading"
                      :headers="getHeaders"
                      :items="table.data"
                      :options="table.options"
                      sort-by="product"
                      class="elevation-1"
                      fixed-header
                      :height="table.data.length >= 10 ? 600 : 400"
                      hide-default-footer>
                      <template
                        v-slot:item.amount="{ item }"
                        v-if="['sent'].includes(detail.status) && detail.isRead && purchaseOrderPermissions['change-purchase-order-update-product-price']">
                        <div class="d-flex justify-space-between">
                          <v-edit-dialog
                            :return-value.sync="item.amount"
                            large
                            dark
                            persistent
                            @save="save(item)"
                            cancel-text="Cancelar"
                            save-text="Guardar">
                            ${{ (item.amount || 0) | toFixNumber(2) }}
                            <v-icon light small>mdi-border-color</v-icon>
                            <template v-slot:input>
                              <v-text-field
                                v-model.number="item.amount"
                                label="Edit"
                                single-line>
                              </v-text-field>
                            </template>
                          </v-edit-dialog>
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-btn
                                v-on="on"
                                icon
                                color="secondary"
                                x-small
                                depressed
                                @click="updatePrice(item)"
                              >
                                <v-icon small>
                                  mdi-autorenew
                                </v-icon>
                              </v-btn>
                            </template>
                            <span>Actualizar precio</span>
                          </v-tooltip>
                        </div>
                      </template>
                      <template v-else v-slot:item.amount="{ item }">
                        <div class="text-right">
                          ${{ (item.amount || 0) | toFixNumber(2) | numberWithComma }}
                        </div>
                      </template>
                      <template v-slot:item.quantityConfirmed="{ item }">
                        <v-edit-dialog v-if="['sent'].includes(detail.status) && detail.isRead && purchaseOrderPermissions['change-purchase-order-update-product-quantity-confirmed']"
                          :return-value.sync="item.quantityConfirmed"
                          large
                          dark
                          persistent
                          @save="save(item)"
                          cancel-text="Cancelar"
                          save-text="Guardar">
                          {{ item.quantityConfirmed }}
                          <v-icon light small>mdi-border-color</v-icon>
                          <template v-slot:input>
                            <v-text-field
                              v-model.number="item.quantityConfirmed"
                              label="Edit"
                              type="number"
                              single-line>
                            </v-text-field>
                          </template>
                        </v-edit-dialog>
                        <template v-else>
                          <div class="text-right">
                            <span v-bind:class="{'red--text': item.quantityRequested !== item.quantityConfirmed}">
                              {{ item.quantityConfirmed }}
                            </span>
                          </div>
                        </template>
                      </template>
                      <template v-slot:item.unit.name="{ item }">
                        <div class="d-flex justify-space-between">
                          <div>
                            <div>
                              {{ item.unit.name }}
                            </div>
                            <div v-if="item.unit._id !== item.contentUnit" class="grey--text">
                              de {{ item.contentQuantity }} {{ getUnitName(item.contentUnit) }} c/u
                            </div>
                          </div>
                          <div v-if="['sent'].includes(detail.status) && detail.isRead && purchaseOrderPermissions['change-purchase-order-update-product-quantity-confirmed']">
                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  v-on="on"
                                  icon
                                  color="secondary"
                                  x-small
                                  depressed
                                  @click="openEditVariantInOrder(item)"
                                >
                                  <v-icon small>
                                    mdi-pencil
                                  </v-icon>
                                </v-btn>
                              </template>
                              <span>Cambiar presentación</span>
                            </v-tooltip>
                          </div>
                        </div>
                      </template>
                      <template
                        v-slot:item.quantityReceived="{ item }"
                        v-if="(detail.status === 'invoiced' || (detail.status === 'confirmed' && countryRestaurant !== 'MX')) && ['manager', 'stockmanager'].includes($is())">
                        <v-text-field
                          v-model.number="item.quantityReceived"
                          type="number"
                          label="Edit"
                          single-line>
                        </v-text-field>
                      </template>
                      <template v-slot:item.ieps="{ item }">
                        ${{ (item.ieps || 0) | toFixNumber(2) }}
                      </template>
                      <template v-slot:item.iva="{ item }">
                        ${{ (item.iva || 0) | toFixNumber(2) }}
                      </template>
                      <template v-slot:item.total="{ item }">
                        ${{ (item.total || 0) | toFixNumber(2) | numberWithComma }}
                      </template>
                      <template v-slot:item.actions="{ item }">
                        <v-btn
                          x-small
                          fab
                          depressed
                          text
                          class="mr-2"
                          color="error"
                          @click="openRemoveDialog(item)">
                          <v-icon small>mdi-delete</v-icon>
                        </v-btn>
                      </template>
                      <template v-slot:footer v-if="['sent'].includes(detail.status) && detail.isRead === true && purchaseOrderPermissions['change-purchase-order-add-product']">
                        <v-btn
                          tile
                          text
                          color="primary"
                          width="100%"
                          @click="openAddProductDialog">
                          <v-icon>
                            mdi-plus
                          </v-icon>
                          {{ $t('orders.buttons.addProduct') }}
                        </v-btn>
                      </template>
                    </v-data-table>
                  </v-tab-item>
                  <v-tab-item key="Servicios">
                    <v-data-table
                      :loading-text="servicesTable.title"
                      :loading="servicesTable.loading"
                      :headers="servicesTable.headers"
                      :items="servicesTable.data"
                      :options="servicesTable.options"
                      sort-by="product"
                      class="elevation-1"
                      fixed-header
                      :height="table.data.length >= 10 ? 600 : 400"
                      hide-default-footer>
                      <template v-slot:footer>
                        <v-btn
                          tile
                          text
                          color="primary"
                          width="100%"
                          @click="openAddService">
                          <v-icon>
                            mdi-plus
                          </v-icon>
                          Agregar servicio
                        </v-btn>
                      </template>
                      <template v-slot:item.actions="{ item }">
                        <v-tooltip left>
                          <template
                            v-slot:activator="{ on }">
                            <v-btn
                              fab
                              x-small
                              depressed
                              color="error"
                              v-on="on"
                              @click="remove(item)">
                              <v-icon>mdi-delete</v-icon>
                            </v-btn>
                          </template>
                          <span>Eliminar servicio</span>
                        </v-tooltip>
                      </template>
                    </v-data-table>
                  </v-tab-item>
                </v-tabs-items>
              </div>

              <div v-else>
                <v-alert dense type="info" v-if="!['received', 'paid'].includes(detail.status) && !detail.payable">
                  <div>
                    Esta orden de compra no se pagará a través de eato.
                  </div>
                  <div>
                    El pago a este proveedor tendrás que hacerlo directamente con él,
                    sin embargo, podrás subir la factura emitida por estos productos para llevar un control de tus finanzas desde eato.
                  </div>
                </v-alert>

                <div class="d-flex justify-end">
                  <div class="font-weight-bold mb-2">
                    Cantidad de artículos: {{ totalProducts }}
                  </div>
                </div>
                <v-data-table
                  :loading-text="table.title"
                  :server-items-length="table.total"
                  :loading="table.loading"
                  :headers="getHeaders"
                  :items="table.data"
                  :options="table.options"
                  sort-by="product"
                  class="elevation-1"
                  fixed-header
                  :height="table.data.length >= 10 ? 600 : 400"
                  hide-default-footer>
                  <template
                    v-slot:item.amount="{ item }"
                    v-if="['sent', 'confirmed'].includes(detail.status) && $is() === 'provider' && purchaseOrderPermissions['change-purchase-order-update-product-quantity-confirmed']">
                    <v-edit-dialog
                      :return-value.sync="item.amount"
                      large
                      dark
                      persistent
                      @save="save(item)"
                      cancel-text="Cancelar"
                      save-text="Guardar">
                      ${{ (item.amount || 0) | toFixNumber(2) }}
                      <v-icon light small>mdi-border-color</v-icon>
                      <template v-slot:input>
                        <v-text-field
                          v-model.number="item.amount"
                          label="Edit"
                          single-line>
                        </v-text-field>
                      </template>
                    </v-edit-dialog>
                  </template>
                  <template v-else v-slot:item.amount="{ item }">
                    <div class="text-right">
                      ${{ (item.amount || 0) | toFixNumber(2) | numberWithComma }}
                    </div>
                  </template>
                  <template v-slot:item.unit.name="{ item }">
                    <div>
                      {{ item.unit.name }}
                    </div>
                    <div v-if="item.unit._id !== item.contentUnit" class="grey--text">
                      de {{ item.contentQuantity }} {{ getUnitName(item.contentUnit) }} c/u
                    </div>
                  </template>
                  <template v-slot:item.amountWithTax="{ item }">
                    <div class="text-right">
                      ${{ (item.amountWithTax || 0) | toFixNumber(2) | numberWithComma }}
                    </div>
                  </template>
                  <template v-slot:item.quantityConfirmed="{ item }">
                    <v-edit-dialog
                      v-if="['sent', 'confirmed'].includes(detail.status) && $is() === 'provider' || ['sent'].includes(detail.status) && $is() !== 'provider'"
                      :return-value.sync="item.quantityConfirmed"
                      large
                      dark
                      persistent
                      @save="save(item)"
                      cancel-text="Cancelar"
                      save-text="Guardar">
                      {{ item.quantityConfirmed }}
                      <v-icon light small>mdi-border-color</v-icon>
                      <template v-slot:input>
                        <v-text-field
                          v-model.number="item.quantityConfirmed"
                          label="Edit"
                          type="number"
                          single-line>
                        </v-text-field>
                      </template>
                    </v-edit-dialog>
                    <template v-else>
                      <div class="text-right">
                        <span v-bind:class="{'red--text': item.quantityRequested !== item.quantityConfirmed}">
                          {{ item.quantityConfirmed }}
                        </span>
                      </div>
                    </template>
                  </template>
                  <template
                    v-slot:item.quantityReceived="{ item }"
                    v-if="(detail.status === 'invoiced' || (detail.status === 'confirmed' && (detail.provider.receiveWithoutInvoice || countryRestaurant !== 'MX'))) && ['manager', 'stockmanager'].includes($is()) && !isRead">
                    <v-text-field
                      v-model.number="item.quantityReceived"
                      type="number"
                      label="Edit"
                      single-line
                      @input="calculateTotalOnReceive(item)">
                    </v-text-field>
                  </template>
                  <template v-slot:item.totalWithTax="{ item }">
                    ${{ (item.totalWithTax || 0) | toFixNumber(2) | numberWithComma }}
                  </template>
                  <template v-slot:item.total="{ item }">
                    ${{ (item.total || 0) | toFixNumber(2) | numberWithComma }}
                  </template>
                  <template v-slot:item.type="{ item }">
                    {{ item.type === 'product' ? 'Producto' : 'Servicio' }}
                  </template>
                  <template v-slot:[`item.choice.brand`]="{ item }">
                    {{ item.choice && item.choice.brand ? item.choice.brand : '-' }}
                  </template>
                  <template v-slot:[`item.choice.description`]="{ item }">
                    {{ item.choice && item.choice.description ? item.choice.description : '-' }}
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <v-btn
                      x-small
                      fab
                      depressed
                      text
                      class="mr-2"
                      color="error"
                      @click="openRemoveDialog(item)">
                      <v-icon small>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </div>

              <v-row v-if="detail.status === 'created' && ['manager', 'buyer'].includes($is())">
                <v-col md="12">
                  <v-textarea
                    outlined
                    name="input-7-4"
                    label="Agrega notas para el proveedor"
                    v-model="notes"
                  />
                </v-col>
              </v-row>

              <v-row>
                <v-col md="12" class="d-flex flex-wrap flex-column flex-md-row justify-end">
                  <v-btn
                    v-on:click="send"
                    color="success"
                    class="mb-3 mb-md-0"
                    v-if="detail.status === 'created' && purchaseOrderPermissions['change-purchase-order-status-to-sent'] && !isRead">
                    Enviar al provedor
                  </v-btn>
                  <v-btn
                    @click="openEditDialog()"
                    color="success"
                    class="mb-3 mb-md-0 mr-3"
                    v-if="['created', 'sent', 'confirmed', 'invoiced'].includes(detail.status) && purchaseOrderPermissions['change-purchase-order-area'] && !isRead">
                    Cambiar área
                  </v-btn>
                  <v-btn
                    v-on:click="read"
                    color="success"
                    class="mb-3 ml-md-1"
                    v-if="['sent'].includes(detail.status) && !detail.isRead && purchaseOrderPermissions['change-purchase-order-to-read'] && !isRead">
                    Mandar a confirmar
                  </v-btn>
                  <v-btn
                    @click="saveChanges"
                    color="success"
                    class="mb-3 ml-md-1"
                    v-if="['sent'].includes(detail.status) && detail.isRead && isUserProvider && purchaseOrderPermissions['change-purchase-order-status-to-confirmed']">
                    Guardar cambios
                  </v-btn>
                  <v-btn
                    v-on:click="onPropagateDialog"
                    color="success"
                    class="mb-3 ml-md-1"
                    v-if="['sent'].includes(detail.status) && detail.isRead && isUserProvider && purchaseOrderPermissions['change-purchase-order-status-to-confirmed']">
                    Confirmar
                  </v-btn>
                  <!-- <v-btn
                    v-on:click="localConfirm"
                    color="success"
                    class="mb-3 mr-1" v-if="['sent'].includes(detail.status) && !isUserProvider && purchaseOrderPermissions['change-purchase-order-status-to-confirmed'] && !isRead">
                    Confirmar
                  </v-btn> -->
                  <v-btn
                    v-on:click="pay"
                    color="success"
                    class="mb-3 mr-1" v-if="(['received'].includes(detail.status) && !detail.payable && purchaseOrderPermissions['change-purchase-order-status-to-paid'])">
                    Marcar orden pagada
                  </v-btn>
                  <v-btn
                    data-cy="recieve"
                    v-on:click="receive"
                    color="success"
                    v-show="show"
                    class="mb-3 mb-md-0 ml-md-1" v-if="detail.status === 'invoiced' && !isUserProvider && purchaseOrderPermissions['change-purchase-order-status-to-received'] && !isRead">
                    Recibir mercancía
                  </v-btn>
                  <v-btn
                    data-cy="recieve"
                    v-on:click="receiveWithoutInvoice"
                    color="success"
                    class="mb-3 mb-md-0 ml-md-1"
                    v-if="detail.status === 'confirmed'
                      && !isUserProvider
                      && purchaseOrderPermissions['change-purchase-order-status-to-received']
                      && (detail.provider.receiveWithoutInvoice || countryRestaurant !== 'MX')">
                    Recibir mercancía
                  </v-btn>
                  <v-btn
                    v-on:click="attachInvoice(order)"
                    color="success"
                    class="mb-3 mb-md-0 ml-md-1"
                    v-if="['received', 'pending_payment', 'paid'].includes(detail.status)
                      && isValidInvoice
                      && purchaseOrderPermissions['upload-purchase-order-invoice']
                      && detail.provider.receiveWithoutInvoice
                      && countryRestaurant == 'MX'"
                    >
                    Adjuntar factura
                  </v-btn>
                  <v-btn
                    v-on:click="attachInvoice(order)"
                    color="success"
                    class="mb-3 mb-md-0 ml-md-1"
                    v-if="detail.status === 'invalid_invoice'
                      && purchaseOrderPermissions['upload-purchase-order-invoice']
                      && detail.provider.receiveWithoutInvoice
                      && countryRestaurant == 'MX'"
                    >
                    Volver a adjuntar factura
                  </v-btn>
                  <v-btn
                    v-on:click="openCreditNoteDialog"
                    color="success"
                    v-show="show"
                    class="mb-3 mb-md-0 ml-md-1"
                    v-if="['invalid', 'invoiced'].includes(detail.status)
                      && ['manager', 'stockmanager', 'buyer', 'provider', 'provider-buyer'].includes($is())
                      && purchaseOrderPermissions['upload-credit-note']
                      && countryRestaurant == 'MX' && !isRead"
                    >
                    Subir nota de crédito
                  </v-btn>
                  <v-btn
                    v-on:click="onDeliverDialog"
                    color="success"
                    class="mb-3 mb-md-0 ml-md-1"
                    v-if="!$isMobile && ['invoiced'].includes(detail.status) && isUserProvider && purchaseOrderPermissions['change-purchase-order-status-to-received']">
                    Entregar mercancía
                  </v-btn>
                  <v-btn
                    v-on:click="uploadInvoice(order)"
                    color="success"
                    class="mb-3 ml-md-1"
                    v-if="['confirmed', 'invalid'].includes(detail.status)
                      && purchaseOrderPermissions['upload-purchase-order-invoice']
                      && countryRestaurant == 'MX'
                      && !isRead"
                    >
                    Subir factura
                  </v-btn>
                  <v-btn
                    v-on:click="onCancelOrderDialog"
                    color="error"
                    class="ml-md-1"
                    v-show="show"
                    v-if="isCancelable && !isRead">
                    Cancelar orden de compra
                  </v-btn>
                  <!-- <v-btn
                    v-on:click="onRefundOrderDialog"
                    color="error"
                    class="ml-md-1"
                    v-if="['paid', 'pending_payment', 'received'].includes(detail.status)">
                    Solicitar devolución de saldo
                  </v-btn> -->
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </v-navigation-drawer>

    <v-dialog @keydown.esc="deliverDialog=false" v-model="deliverDialog" persistent max-width="400px">
      <v-card>
        <v-card-title>
          <span class="headline">Recibir mercancía de {{ detail.uuid }}</span>
        </v-card-title>
        <v-card-text>
          <div class="py-3">
            Esta información debe llenarla el encargado de recibir la mercancía.
          </div>
          <div class="py-3">
            <div class="pb-3">
              ¿Estás de acuerdo con la cantidad recibida?
            </div>
            <div class="pb-3">
              <v-btn-toggle
                v-model="agreeDeliver"
                rounded
              >
                <v-btn small color="primary">
                  No
                </v-btn>
                <v-btn small color="primary" data-cy="accept">
                  Sí
                </v-btn>
              </v-btn-toggle>
            </div>
          </div>
          <v-text-field
            data-cy="nip"
            v-if="agreeDeliver === 1"
            dense
            rounded
            outlined
            hide-details
            label="NIP"
            ref="nip"
            placeholder="Introduce tu NIP de seguridad"
            :append-icon="showNip ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showNip ? 'text' : 'password'"
            :rules="rules.required"
            v-model="deliverForm.nip"
            @click:append="showNip = !showNip"
          />
          <div
            v-if="agreeDeliver === 0"
            class="py-3">
            <b>Lo sentimos</b>, pero no es posible recibir la orden de compra ya que nos has indicado que las cantidades son incorrectas.<br>
            No te preocupes, sigue las instrucciones:
            <ol>
              <li>Recibe la mercancia</li>
              <li>Tan pronto te sea posible accede a tu cuenta de Eato</li>
              <li>Abre la orden de compra</li>
              <li>Captura las cantidades que recibiste</li>
              <li>El proveedor generará una nueva factura.</li>
            </ol>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            rounded
            small
            depressed
            @click="onCloseDeliverDialog">
            Cancelar
          </v-btn>
          <v-btn
            data-cy="deliver"
            color="primary"
            rounded
            small
            depressed
            :disabled="!agreeDeliver || agreeDeliver === 0 || !deliverForm.nip"
            @click="deliver">
            Recibir
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog @keydown.esc="propagateDialog=false" v-model="propagateDialog" persistent max-width="400px">
      <v-card>
        <v-card-title>
          <v-btn
            dark
            fab
            x-small
            outlined
            color="primary"
            class="mr-3"
            @click="onClosePropagateDialog"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <span class="headline">Propagar precio</span>
        </v-card-title>
        <v-card-text>
          <div class="py-3">
            Este proceso puede durar varios minutos, por lo que no podras hacer uso de la plataforma hasta finalizar la propagación.
          </div>
          <div class="py-3">
            <div class="pb-3">
              ¿Deseas propagar el precio de los productos modificados a las ordenes de compras?
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            rounded
            small
            depressed
            @click="confirm(false)">
            No
          </v-btn>
          <v-btn
            color="primary"
            rounded
            small
            depressed
            @click="confirm(true)">
            Si
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog @keydown.esc="generateInvoiceDialog=false" v-model="generateInvoiceDialog" persistent max-width="400px">
      <v-card>
        <v-card-title>
          <span class="headline">Generar factura de orden de compra</span>
        </v-card-title>
        <v-card-text>
          <v-text-field
            data-cy="form-folio"
            v-model="form.Folio"
            dense
            outlined
            rounded
            hide-selected
            hide-no-data
            label="Folio"
            :rules="rules.required.concat(rules.max)"/>
          <v-autocomplete
            data-cy="form-cfdiUse"
            v-model="form.CfdiUse"
            :items="cfdiUses"
            :filter="searchCfdiUse"
            item-text="name"
            item-value="satId"
            dense
            outlined
            rounded
            hide-selected
            hide-no-data
            :rules="rules.required"
            label="Uso de CFDI">
            <template v-slot:item="{ item }">
              {{ item.satId }} | {{ item.name }}
            </template>
          </v-autocomplete>
          <v-autocomplete
            data-cy="form-paymentForm"
            v-model="form.PaymentForm"
            :items="paymentForms"
            :filter="searchPaymentForm"
            item-text="name"
            item-value="satId"
            dense
            outlined
            rounded
            hide-selected
            hide-no-data
            :rules="rules.required"
            label="Forma de pago">
            <template v-slot:item="{ item }">
              {{ item.satId }} | {{ item.name }}
            </template>
          </v-autocomplete>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            rounded
            small
            depressed
            @click="onCloseGenerateInvoiceDialog">
            No
          </v-btn>
          <v-btn
            data-cy="generateInvoice"
            color="primary"
            rounded
            small
            depressed
            @click="generateInvoice">
            Generar factura
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog @keydown.esc="cancelDialog=false" v-model="cancelDialog" persistent max-width="400px">
      <v-card>
        <v-card-title>
          <span class="headline">¿Quieres CANCELAR la orden {{ detail.uuid }}?</span>
        </v-card-title>
        <v-card-text>
          Al cancelar la orden de compra se le notificará al restaurante que su pedido ha sido cancelado y que si desea volver a comprar los productos contigo deberá hacer una nueva orden de compra.
        </v-card-text>
        <v-card-actions>
          <v-radio-group v-model="selectedReason">
            <v-radio value="wrong_provider_product" label="Me equivoqué en proveedor / producto"></v-radio>
            <v-radio value="product_not_received" label="No recibí el producto"></v-radio>
            <v-radio value="shortage" label="El proveedor me pidió cancelarlo / Desabasto"></v-radio>
            <v-radio value="product_not_neeed_it" label="Ya no necesito el producto"></v-radio>
            <v-radio value="other" label="Otro: "></v-radio>
          </v-radio-group>
        </v-card-actions>
        <v-card-actions v-if="selectedReason === 'other'">
          <v-text-field v-model="otherMotive" label="Especifica el motivo"></v-text-field>
        </v-card-actions>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            data-cy="cancel"
            color="primary"
            rounded
            small
            depressed
            :disabled="!selectedReason || (selectedReason === 'other' && !otherMotive)"
            @click="cancel">
            Sí, cancelar orden
          </v-btn>
          <v-btn
            color="error"
            rounded
            small
            depressed
            @click="onCloseCancelOrderDialog">
            No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog @keydown.esc="refundDialog=false" v-model="refundDialog" persistent max-width="400px">
      <v-card>
        <v-card-title>
          <span class="headline">¿Quieres SOLICITAR DEVOLUCIÓN de la orden {{ detail.uuid }}?</span>
        </v-card-title>
        <v-card-text>
          <div>
            Al solicitar una devolución tu orden será cancelada y se eliminará la factura para que la vuelvas a subir.
          </div>
          <div>
            <v-checkbox
              v-model="forceCancelInvoice"
              label="Quiero que la factura se cancele"
            />
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            rounded
            small
            depressed
            @click="refund">
            Sí, devolver saldo
          </v-btn>
          <v-btn
            color="primary"
            rounded
            small
            depressed
            @click="onCloseRefundOrderDialog">
            No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog @keydown.esc="removeDialog=false" v-model="removeDialog" persistent max-width="400px">
      <v-card>
        <v-card-title>
          <span class="headline">¿Borrar {{ itemToRemove.name }}?</span>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            outlined
            rounded
            small
            depressed
            @click="onCloseRemoveDialog">
            No
          </v-btn>
          <v-btn
            color="primary"
            rounded
            small
            depressed
            @click="removeProduct">
            Sí
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog @keydown.esc="creditNoteDialog=false" v-model="creditNoteDialog" persistent max-width="400px">
      <v-card>
        <v-card-title>
          <div class="d-flex">
            <div class="primary--text">
              Nota de crédito
            </div>
            <v-spacer />
            <v-btn
              color="black darken-1"
              @click="onCloseCreditNoteDialog"
              text
              icon>
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </v-card-title>
        <v-card-text>
          <v-form v-model="form.isValid" ref="form">
            <v-file-input
              v-model="form.xmlFiles"
              multiple
              label="XML Files"
              accept=".xml"
              required>
            </v-file-input>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            rounded
            small
            depressed
            @click="uploadCreditNote">
            Subir nota de crédito
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <bill-dialog
      :dialog="billDialog"
      :order="order"
      @close="closeBillDialog">
    </bill-dialog>

    <attach-dialog
      :dialog="attachDialog"
      :order="order"
      @close="closeAttachDialog">
    </attach-dialog>

    <v-dialog
      @keydown.esc="servicesDialog.open=false"
      v-model="servicesDialog.open"
      max-width="400"
      persistent>
      <v-card>
        <v-card-title>
          ¿Cuál servicio agregarías?
        </v-card-title>
        <v-card-text>
          <v-form v-model="servicesDialog.valid" ref="serviceForm">
            <v-row>
              <v-col cols="12">
                <v-autocomplete
                  v-model="servicesDialog.form.service"
                  :items="servicesDialog.services"
                  :loading="servicesDialog.loading"
                  label="Servicio"
                  item-text="product.name"
                  item-value="id"
                  clearable
                  hide-selected
                  hide-no-data
                  return-object
                  outlined
                  rounded
                  dense
                  hide-details
                  :rules="servicesDialog.rules.service"
                  :search-input.sync="searchService" />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model.number="servicesDialog.form.amount"
                  label="Precio"
                  outlined
                  rounded
                  dense
                  hide-details
                  :rules="servicesDialog.rules.amount"
                  type="number" />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            color="primary"
            outlined
            rounded
            small
            depressed
            @click="onCloseAddServiceDialog">
            Ninguno
          </v-btn>
          <v-btn
            rounded
            color="primary"
            @click="addService">
            Agregar servicio
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      @keydown.esc="thanksDialog=false"
      v-model="thanksDialog"
      max-width="400">
      <v-card>
        <v-card-title>
          ¡Gracias!
        </v-card-title>
        <v-card-text>
          Pronto publicaremos los nuevos productos para que más restaurantes puedan usarlos.
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            rounded
            color="primary"
            @click.stop="thanksDialog = false">
            Entendido
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      @keydown.esc="showProductsToInventory=false"
      v-model="showProductsToInventory"
      :max-width="productsToInventory.data.length ? 600 : 450">
      <v-card>
        <v-card-title>
          Productos a inventariar
        </v-card-title>
        <v-card-text>
          <div v-if="productsToInventory.data.length">
           <v-data-table
              :loading-text="productsToInventory.title"
              :loading="productsToInventory.loading"
              :headers="productsToInventory.headers"
              :items="productsToInventory.data"
              :options="productsToInventory.options"
              sort-by="product"
              class="elevation-1"
              fixed-header
              hide-default-footer>
            </v-data-table>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            color="primary"
            rounded
            small
            depressed
            @click="showProductsToInventory = false">
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog @keydown.esc="deliverDialog=false" v-model="deliveryDialog" persistent max-width="400px">
      <v-card>
        <v-card-title>
          <span class="headline">Agregar dirección de entrega</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="deliveryForm">
            <v-container grid-list-xl>
              <v-layout wrap>
                <v-flex class="pa-0" xs12 md12>
                  <v-text-field
                    v-model="formDelivery.address"
                    label="Dirección"
                    placeholder="Mimosa Dorada #980, 28983 Ciudad de México"
                    :rules="rules.deliveryAddress"
                    required>
                  </v-text-field>
                </v-flex>
                <v-flex class="pa-0" xs12 md12>
                  <v-text-field
                    v-model="formDelivery.schedule"
                    label="Horario"
                    :rules="rules.schedule"
                    placeholder="10:00 AM - 21:00 PM"
                    required>
                  </v-text-field>
                </v-flex>
                <v-flex class="pa-0" xs12 md12>
                  <v-text-field
                    v-model="formDelivery.receiver"
                    label="Nombre de quien recibe"
                    placeholder="Manuel V."
                    :rules="rules.receiver"
                    required>
                  </v-text-field>
                </v-flex>
                <v-flex class="pa-0" xs12 md12>
                  <v-textarea
                    v-model="formDelivery.comments"
                    label="Comentarios"
                    solo
                    required>
                  </v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black darken-1" text @click="onCloseDeliveryDialog">Cancelar</v-btn>
          <v-btn color="black darken-1" text @click="submitDelivery">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <AddProductToOrder
      v-if="$is() === 'provider'"
      ref="addProductToOrder"
      @updated="load()"
    />

    <SendOrderByEmail
      ref="sendOrderByEmail"
      :order="order._id"
    />

    <AddCSD
      :isOpenDialog="onAddCSD"
      @close="closeOnAddCSD"
    />

    <CreditNoteViewer
      :isOpenDialog.sync="creditNoteViewerOpen"
      :order="detail"
      :file="file"
      :key="`creditNote-${detail.id}`"
      @close="creditNoteViewerOpen = false"/>

    <InvoiceViewer
      ref="invoice"
      :order="detail"
      :key="`invoice-${detail.id}`"
      @close="invoiceViewerOpen = false"/>

    <ChangePurchaseOrderArea
      :order="detail"
      ref="editDialog"
      @close="emitUpdate"
    />

    <EditVariantInOrder
      v-if="$is() === 'provider'"
      ref="editVariantInOrder"
      @updated="load()"
    />

    <CheckStatusInvoice
      ref="checkStatusInvoice"
    />

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <v-overlay :value="overlayPropagate" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>
<script>
import CheckStatusInvoice from '@/components/modals/CheckStatusInvoice'
import AddProductToOrder from '@/components/modals/AddProductToOrder'
import AddCSD from '@/components/modals/AddCSD'
import InvoiceViewer from '@/components/modals/InvoiceViewer'
import CreditNoteViewer from '@/components/modals/CreditNoteViewer'
import billDialog from '@/screens/purchaseOrders/Bill'
import attachDialog from '@/components/modals/AttachInvoice'
import Order from '@/models/Order'
import SendOrderByEmail from '@/components/modals/SendOrderByEmail'
import ChangePurchaseOrderArea from '@/components/modals/ChangePurchaseOrderArea'
import { cfdiTypes, cfdiUses, paymentForms } from '@/utils/constants'
import { debounce, cloneDeep } from 'lodash'
import print from 'print-js'
import { mapGetters } from 'vuex'
import EditVariantInOrder from '@/components/modals/EditVariantInOrder'

export default {
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    isRead: {
      type: Boolean,
      default: false
    },
    order: {
      type: Object,
      default: () => ({})
    },
    show: {
      type: Boolean,
      default: true
    }
  },
  components: {
    AddProductToOrder,
    billDialog,
    InvoiceViewer,
    CreditNoteViewer,
    AddCSD,
    SendOrderByEmail,
    attachDialog,
    ChangePurchaseOrderArea,
    EditVariantInOrder,
    CheckStatusInvoice
  },
  data () {
    let orderModel = new Order()

    return {
      deliveryDialog: false,
      formDelivery: {
        address: null,
        schedule: null,
        comments: null,
        receiver: null
      },
      selected: null,
      deliveryAddress: {
        address: null,
        schedule: null,
        comments: null,
        receiver: null
      },
      showProductsToInventory: false,
      invoiceViewerOpen: false,
      creditNoteViewerOpen: false,
      onAddCSD: false,
      panel: {
        activated: false
      },
      items: [
        { title: 'Visualizador de productos originales' }
      ],
      tab: 0,
      orderModel,
      overlay: false,
      disablee: false,
      cancelInvoiceDialog: false,
      generateInvoiceDialog: false,
      addProductDialog: false,
      billDialog: false,
      cancelDialog: false,
      refundDialog: false,
      removeDialog: false,
      thanksDialog: false,
      attachDialog: false,
      creditNoteDialog: false,
      forceCancelInvoice: false,
      detail: {},
      table: {
        title: 'Loading products',
        loading: false,
        data: [],
        total: 0,
        headers: this.getHeaders,
        options: {
          itemsPerPage: 15,
          page: 1
        }
      },
      tableOriginalProducts: {
        title: 'Loading products',
        loading: false,
        data: [],
        total: 0,
        headers: this.getHeaders,
        options: {
          itemsPerPage: 15,
          page: 1
        }
      },
      productsToInventory: {
        title: 'Loading products',
        loading: false,
        data: [],
        headers: [
          { text: 'Producto', value: 'product', sortable: false },
          { text: 'Cantidad a Invetariar', value: 'quantity', sortable: false },
          { text: 'Unidad de Medida', value: 'unit', sortable: false }
        ],
        total: 0,
        options: {
          itemsPerPage: 10,
          page: 1
        }
      },
      servicesTable: {
        title: 'Loading services',
        loading: false,
        data: [],
        headers: [
          { text: 'Clave SAT', value: 'satCode' },
          { text: 'Nombre', value: 'product.name' },
          { text: 'Precio', value: 'amount' },
          { text: 'Acciones', value: 'actions' }
        ],
        total: 0,
        options: {
          itemsPerPage: 15,
          page: 1
        }
      },
      rules: {
        required: [v => !!v || this.$t('validations.required')],
        max: [v => v.length <= 9 || this.$t('validations.max', { count: 9 })],
        deliveryAddress: [v => !!v || 'Address is required'],
        schedule: [v => !!v || 'Schedule is required'],
        receiver: [v => !!v || 'Receiver is required']
      },
      file: '',
      itemToRemove: {},
      cfdiUses,
      paymentForms,
      cfdiTypes,
      form: {
        Folio: '',
        CfdiUse: cfdiUses[0].satId,
        PaymentForm: paymentForms[2].satId,
        xmlFiles: []
      },
      invoice: {},
      invoiceStatuses: {
        active: {
          text: 'Activa',
          color: 'primary'
        },
        canceled: {
          text: 'Cancelada',
          color: 'red'
        }
      },
      invoiceSource: {
        facturapi: 'EATO',
        xml: 'Externo'
      },
      servicesDialog: {
        open: false,
        loading: false,
        services: [],
        valid: false,
        form: {
          service: null,
          amount: 0,
          quantity: 1
        },
        rules: {
          satCode: [v => !!v || this.$t('validations.satCode')],
          service: [v => !!v || this.$t('validations.service')],
          amount: [v => !!v || this.$t('validations.amount')]
        }
      },
      searchService: '',
      deliverDialog: false,
      propagateDialog: false,
      deliverForm: {
        nip: null
      },
      agreeDeliver: null,
      showNip: false,
      notes: '',
      isModificated: false,
      selectedArea: {},
      selectedReason: '',
      otherMotive: ''
    }
  },
  watch: {
    order: async function (value) {
      if (value && (value._id || (value.$ && value.$.id))) {
        this.orderModel = new Order(value.$ || value)
        await this.load()
        this.defaultAddress()
      }
    },
    dialog: function (val) {
      this.panel.activated = val
    },
    searchService: debounce(async function (val) {
      const params = {
        name: val,
        type: 'service'
      }
      const response = await this.$api.get(`/v1/catalog`, params)
      this.servicesDialog.services = response.data
    }, 300)
  },
  computed: {
    actualDate () {
      const nowDate = new Date()
      if (nowDate.getDay() === 4) return true

      return false
    },
    ...mapGetters({
      countryRestaurant: 'currentRestaurant/country'
    }),
    overlayPropagate () {
      return this.$store.state.currentProvider.loadingPropagate
    },
    totalProducts () {
      return this.table.data.length
    },
    quantityOriginalProducts () {
      return this.tableOriginalProducts.data.length
    },
    getHeaders () {
      const _headers = [
        { text: '#', value: 'number', sortable: false },
        { text: 'Insumo', value: 'name', sortable: false },
        { text: 'Tipo', value: 'type', sortable: false },
        { text: 'Marca', value: 'choice.brand', sortable: false },
        { text: 'Descripción', value: 'choice.description', sortable: false }
      ]

      if (['provider', 'provider-buyer'].includes(this.$is())) {
        if (!['sent'].includes(this.detail.status) || !this.detail.isRead) {
          _headers.push(
            { text: 'Cantidad solicitada', value: 'quantityRequested', sortable: false, align: 'end' },
            { text: 'Unidad de medida', value: 'unit.name', sortable: false }
          )
        }
      } else {
        _headers.push(
          { text: 'Cantidad solicitada', value: 'quantityRequested', sortable: false, align: 'end' }
        )

        if (['invoiced', 'received', 'invalid'].includes(this.detail.status)) {
          _headers.push({ text: 'Cantidad confirmada', value: 'quantityConfirmed', sortable: false, align: 'end' })
        }

        if (
          (['invoiced'].includes(this.detail.status) ||
          (['confirmed'].includes(this.detail.status) && (this.detail.provider.receiveWithoutInvoice || this.countryRestaurant !== 'MX'))) &&
          ['manager', 'stockmanager'].includes(this.$is())
        ) {
          _headers.push({ text: 'Cantidad recibida', value: 'quantityReceived', sortable: false, align: 'end' })
        }

        if (['received', 'invalid', 'pending_payment', 'paid'].includes(this.detail.status)) {
          if (this.$is() === 'provider') {
            _headers.push({ text: 'Cantidad entregada', value: 'quantityReceived', sortable: false, align: 'end' })
          } else {
            _headers.push({ text: 'Cantidad recibida', value: 'quantityReceived', sortable: false, align: 'end' })
          }
        }

        _headers.push(
          { text: 'Unidad de medida', value: 'unit.name', sortable: false }
        )
      }

      if (['sent', 'confirmed'].includes(this.detail.status) && !this.isRead) {
        _headers.push({ text: 'Cantidad confirmada', value: 'quantityConfirmed', sortable: false })

        if (this.$is() === 'provider') {
          _headers.push(
            { text: 'Unidad de medida', value: 'unit.name', sortable: false },
            { text: 'Precio unitario (Sin impuestos)', value: 'amount', sortable: false }
          )
          if (this.hasTaxes(this.table.data)) {
            _headers.push({ text: 'IVA', value: 'iva', sortable: false })
          }
          if (this.hasTaxes(this.table.data)) {
            _headers.push({ text: 'IEPS', value: 'ieps', sortable: false })
          }
        } else {
          _headers.push({ text: 'Precio unitario (Con impuestos)', value: 'amountWithTax', sortable: false, align: 'end' })
        }
      } else {
        _headers.push({ text: 'Precio unitario (Con impuestos)', value: 'amountWithTax', sortable: false, align: 'end' })
      }

      if (['sent', 'confirmed'].includes(this.detail.status)) {
        if (this.$is() === 'provider') {
          _headers.push({ text: 'Total', value: 'total', sortable: false, align: 'end' })
        } else {
          _headers.push({ text: 'Total', value: 'totalWithTax', sortable: false, align: 'end' })
        }
      } else {
        _headers.push({ text: 'Total', value: 'totalWithTax', sortable: false, align: 'end' })
      }

      if (this.detail.status === 'created' && ['manager', 'stockmanager'].includes(this.$is()) && this.purchaseOrderPermissions['delete-purchase-order-product']) {
        _headers.push({ text: 'Acciones', value: 'actions', sortable: false })
      }

      return _headers
    },
    total () {
      return this.detail.total
    },
    totalOriginalProducts () {
      return this.tableOriginalProducts.data.length ? this.tableOriginalProducts.data.reduce((acc, num) => {
        acc = acc + num.totalWithTax
        return acc
      }, 0) : 0
    },
    totalToPay () {
      let total = this.detail.total

      if (['sent', 'confirmed'].includes(this.detail.status) && this.$is() === 'provider') {
        total = this.table.data.length
          ? this.table.data.reduce((acc, num) => {
            acc = acc + num.total
            return acc
          }, 0)
          : 0
      }

      return total
    },
    subtotal () {
      return this.table.data.length ? this.table.data.reduce((acc, num) => {
        acc = acc + (num.amount * num.quantityConfirmed)
        return acc
      }, 0) : 0
    },
    iva () {
      return this.table.data.length ? this.table.data.reduce((acc, product) => {
        const iva = product.taxes.find(tax => tax.satCode === '002' && tax.base > 0)
        acc = acc + (iva ? (iva.base / 100) * (product.amount + this.ieps) * product.quantityConfirmed : 0)
        return acc
      }, 0) : 0
    },
    ieps () {
      return this.table.data.length ? this.table.data.reduce((acc, product) => {
        const iepsTaxes = product.taxes.filter(tax => tax.satCode === '003' && tax.base > 0)
        const hasBaseAmount = (iepsTaxes || []).every(tax => tax.baseAmount && tax.baseAmount >= 0)
        if (hasBaseAmount) {
          const taxesAmount = iepsTaxes.reduce((acc, tax) => {
            const base = tax.isQuota ? tax.base : (tax.base / 100)
            return acc + (tax.baseAmount * base)
          }, 0)
          return taxesAmount
        }
        const ieps = product.taxes.find(tax => tax.satCode === '003' && tax.base > 0)
        const amount = product.amount - (product.discount || 0)
        acc = acc + (ieps ? (ieps.base / 100) * amount * product.quantityConfirmed : 0)
        return acc
      }, 0) : 0
    },
    restaurant () {
      return this.$store.state.currentRestaurant.data
    },
    isCancelable () {
      return !['received', 'paid', 'canceled', 'pending_payment', 'invalid_invoice'].includes(this.detail.status) && this.purchaseOrderPermissions['change-purchase-order-status-to-cancelled']
    },
    provider () {
      return this.$store.state.currentProvider.data || ''
    },
    copyToLink () {
      return `${process.env.VUE_APP_API_URL}/v1/orders/${this.orderModel.$._id}/download`
    },
    purchaseOrderPermissions () {
      return this.$store.state.login.permissions['purchase-orders'].components['purchase-orders-list'].actions
    },
    notificationOrdersPermissions () {
      return this.$store.state.login.permissions['notifications'].components['orders'].actions
    },
    isUserProvider () {
      return this.$store.state.userProvider
    },
    isValidInvoice () {
      const totalInvoice = this.detail.invoices.length ? this.detail.invoices.reduce((acc, invoice) => {
        acc = acc + invoice.total
        return acc
      }, 0) : 0
      return this.detail.total.toFixed(2) !== totalInvoice.toFixed(2)
    },
    totalInvoices () {
      if (!this.detail.invoices) return 0
      return this.detail.invoices.reduce((acc, curr) => acc + curr.total, 0)
    }
  },
  mounted () {
    window.addEventListener('keydown', this.keyDownHandler)
  },
  destroyed () {
    window.removeEventListener('keydown', this.keyDownHandler)
  },
  methods: {
    downloadOrderInvoice (item) {
      let url = `${process.env.VUE_APP_API_URL}/v1/invoices/${item._id}/download-invoice-pdf`
      url += `?access_token=${this.$store.state.login.token}`
      return url
    },
    async downloadInvoice (item) {
      const response = await this.$api.get(`/v1/orders/${this.detail._id}/invoices/${item._id}`)
      var element = document.createElement('a')
      element.setAttribute('href', 'data:text/xml;charset=utf-8,' + encodeURIComponent(response.content))
      element.setAttribute('download', `invoice-${item.uuid}`)

      element.style.display = 'none'
      document.body.appendChild(element)

      element.click()

      document.body.removeChild(element)
    },
    async checkStatusInvoice (item) {
      this.overlay = true
      try {
        const { response } = await this.orderModel.checkStatus(item._id)
        this.openCheckStatusInvoice(item, response.data)
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3500, type: 'error', position: 'top-center', iconPack: 'mdi', icon: 'mdi-cancel' })
      }
      this.overlay = false
    },
    keyDownHandler (event) {
      if (event.code === 'Escape') {
        this.isModificated = false
        this.$emit('close')
      }
    },
    defaultAddress () {
      if (this.restaurant.deliveryAddresses.length > 0) {
        const index = this.restaurant.deliveryAddresses.findIndex(x => x.isDefault || !x.isDefault)
        this.selected = index
        const item = this.restaurant.deliveryAddresses[index]
        this.deliveryAddress.address = item.address
        this.deliveryAddress.schedule = item.schedule
        this.deliveryAddress.receiver = item.receiver
        this.deliveryAddress.comments = item.comments
      }
    },
    changeDeliveryAddress () {
      const item = this.restaurant.deliveryAddresses[this.selected]
      this.deliveryAddress.address = item.address
      this.deliveryAddress.schedule = item.schedule
      this.deliveryAddress.receiver = item.receiver
      this.deliveryAddress.comments = item.comments
    },
    onCloseDeliveryDialog () {
      this.formDelivery.address = null
      this.formDelivery.schedule = null
      this.formDelivery.comments = null
      this.formDelivery.receiver = null
      // this.formDelivery.isDefault = false
      this.formDelivery._id = null
      this.deliveryDialog = false
    },
    async submitDelivery () {
      if (this.$refs.deliveryForm.validate()) {
        this.overlay = true
        try {
          // this.changeDefaultAddress(this.formDelivery.isDefault)
          this.restaurant.deliveryAddresses.push(this.formDelivery)
          const response = await this.$api.post(`/v1/restaurants/${this.restaurant._id}/delivery-address`, this.restaurant)
          await this.$store.commit('currentRestaurant/set', response)
          this.onCloseDeliveryDialog()
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
        this.overlay = false
      }
    },
    async updatePrice (item) {
      this.overlay = true
      try {
        const { response } = await this.orderModel.refreshProducts(item._id)
        this.detail = response.data
        this.table.data = this.getProductsPricesWithTaxes(response.data.products)
        this.$emit('update')
        this.$toasted.show(`El precio del producto ${item.name} se actualizo correctamente`, { duration: 3000 })
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    onCopy: function (e) {
      this.$toasted.show('Link copiado', { duration: 3000 })
    },
    async closeOnAddCSD () {
      this.onAddCSD = false
      try {
        const response = await this.$api.get(`/v1/providers/${this.provider._id}/settings`)
        if (response.taxInformation.csdId) {
          this.generateInvoiceDialog = true
        }
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
    },
    getUnitName (unitId) {
      const unit = this.$store.state.login.units.data.find(unit => unit.id === unitId)
      return unit ? unit.name : ''
    },
    openAddProductDialog () {
      this.$refs.addProductToOrder.open(this.detail)
    },
    openSendByEmailDialog () {
      this.$refs.sendOrderByEmail.openDialog()
    },
    findIEPS (taxes) {
      if (taxes.length) {
        const ieps = taxes.find(tax => tax.satCode === '003' && tax.base > 0)
        return ieps
      }
      return null
    },
    hasTaxes (products) {
      return products.some(product => product.taxes.length)
    },
    resetServiceDialog () {
      this.servicesDialog.open = false
      this.servicesDialog.loading = false
      this.servicesDialog.valid = false
      this.servicesDialog.services = []
      this.servicesDialog.serviceSelected = null
      this.servicesDialog.form = {
        valid: false,
        satCode: '',
        name: '',
        amount: 0
      }
      this.searchService = ''
      this.$refs.serviceForm.resetValidation()
    },
    openAddService: function () {
      this.servicesDialog.open = true
    },
    onCloseAddServiceDialog: function () {
      this.servicesDialog.open = false
      this.resetServiceDialog()
    },
    addService: function () {
      const payload = this.servicesDialog.form.service
      payload.amount = this.servicesDialog.form.amount
      payload.quantity = this.servicesDialog.form.quantity
      const valid = this.$refs.serviceForm.validate()
      if (valid) {
        this.servicesTable.data.push(payload)
        this.servicesTable.total = this.servicesTable.data.length
        this.onCloseAddServiceDialog()
      }
    },
    remove (item) {
      const index = this.servicesTable.data.findIndex(i => i.id === item.id)
      this.servicesTable.data.splice(index, 1)
      this.servicesTable.total = this.servicesTable.data.length
    },
    onCloseGenerateInvoiceDialog () {
      this.resetGenerateInvoiceForm()
      this.generateInvoiceDialog = false
    },
    openCreditNoteDialog () {
      this.creditNoteDialog = true
    },
    onCloseCreditNoteDialog () {
      this.resetGenerateInvoiceForm()
      this.creditNoteDialog = false
    },
    uploadCreditNote: async function () {
      try {
        this.overlay = true
        await this.$api.post(`/v1/orders/${this.order._id}/credit-notes`, this.form, { delivery: 'formData' })
        await this.load({
          limit: this.table.options.itemsPerPage,
          skip: (this.table.options.itemsPerPage * (this.table.options.page - 1))
        })
        this.$emit('update')
        this.onCloseCreditNoteDialog()
        this.$toasted.show('La nota de crédito se carga correctamente.', { duration: 3000 })
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    checkLastFolio: async function () {
      try {
        const response = await this.$api.post(`/v1/invoices/${this.$store.state.currentProvider.taxInformation.data.taxInformation.taxId}/folio`)
        this.form.Folio = response.folio
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
    },
    generateInvoice: async function () {
      this.overlay = true
      try {
        let data = {}
        let prices = []
        data = this.form
        for (const product of this.table.data) {
          prices.push({ amount: product.amount, id: product.choice.id, product: product.product, contentUnit: product.contentUnit })
        }
        data.prices = prices
        await this.$api.post(`/v1/orders/${this.detail._id}/invoices`, data)
        this.onCloseGenerateInvoiceDialog()
        if (this.order.id) {
          await this.load({
            limit: this.table.options.itemsPerPage,
            skip: (this.table.options.itemsPerPage * (this.table.options.page - 1))
          })
        }
        this.$emit('update', new Order(this.detail))
        this.$toasted.show('La factura se creó exitosamente.', { duration: 3000 })
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    resetGenerateInvoiceForm () {
      this.form = {
        Folio: '',
        CfdiUse: cfdiUses[0].satId,
        PaymentForm: paymentForms[2].satId,
        InvoiceType: '',
        xmlFiles: []
      }
    },
    searchCfdiUse (item, queryText, itemText) {
      const name = item.name.toLowerCase()
      const searchText = queryText.toLowerCase()
      return name.indexOf(searchText) >= 0
    },
    searchPaymentForm (item, queryText, itemText) {
      const name = item.name.toLowerCase()
      const searchText = queryText.toLowerCase()
      return name.indexOf(searchText) >= 0
    },
    searchCfdiType (item, queryText, itemText) {
      const name = item.name.toLowerCase()
      const searchText = queryText.toLowerCase()
      return name.indexOf(searchText) >= 0
    },
    onGenerateInvoiceDialog () {
      this.generateInvoiceDialog = true
    },
    viewInvoice: async function (invoice) {
      this.$refs.invoice.open(invoice)
    },
    viewCreditNote: async function (file) {
      if (file.xml) {
        this.$refs.invoice.open(file)
      } else {
        this.file = file._id
        this.creditNoteViewerOpen = true
      }
    },
    statusNames (status) {
      if (this.$is() === 'provider') {
        return {
          sent: 'Nueva orden',
          confirmed: 'Confirmada',
          canceled: 'Cancelada',
          invoiced: 'Facturada',
          invalid: 'Factura no coincide',
          received: 'Entregada',
          pending_payment: 'Cobrada',
          paid: 'Cobrada'
        }[status]
      }

      return {
        created: 'Sin enviar',
        sent: 'Enviada',
        confirmed: 'Confirmada',
        canceled: 'Cancelada',
        invoiced: 'Facturada',
        invalid: 'Factura no coincide',
        invalid_invoice: 'Factura no coincide',
        received: 'Recibida',
        pending_payment: 'Pendiente de pago',
        paid: 'Pagada'
      }[status]
    },
    statusColors (status) {
      return {
        created: 'grey',
        sent: 'grey',
        confirmed: 'info',
        canceled: 'red',
        invoiced: 'info',
        invalid: 'red',
        invalid_invoice: 'red',
        received: 'primary',
        pending_payment: 'primary',
        paid: 'primary'
      }[status]
    },
    statusMotiveCancelation (motiveCancelation) {
      return {
        wrong_provider_product: 'Me equivoqué en el proveedor o en el producto',
        product_not_received: 'Producto no recibido',
        shortage: 'Desabasto',
        product_not_neeed_it: 'Ya no necesito el producto'
      }[motiveCancelation]
    },
    save: function (item) {
      const product = this.table.data.find(p => p._id === item._id)
      const iva = product.taxes.find(tax => tax.satCode === '002' && tax.base > 0)
      const ieps = product.taxes.find(tax => tax.satCode === '003' && tax.base > 0)
      const amount = product.amount - (product.discount || 0)
      const productNotModificated = this.detail.products.find(x => x._id === item._id)
      const iepsAmount = ieps ? (ieps.isQuota ? ieps.base : ieps.base / 100) * amount : 0
      if (productNotModificated.amount !== item.amount) this.isModificated = true

      product.taxes[0].baseAmount = item.amount
      product.amount = item.amount
      product.quantityConfirmed = item.quantityConfirmed
      item.iva = iva ? ((iva.base / 100) * item.amount) + iepsAmount : 0
      item.ieps = iepsAmount
      item.total = item.amount * item.quantityConfirmed
      this.calculateTotalProduct()
    },
    calculateTotalOnReceive (item) {
      const product = this.table.data.find(p => p._id === item._id)
      product.amount = item.amount
      product.quantityReceived = item.quantityReceived
      item.totalWithTax = this.calculatePriceProductWithTaxes(product) * item.quantityReceived
      this.calculateTotalProduct()
    },
    calculateTotalProduct () {
      let total = this.detail.total
      if (['sent', 'confirmed'].includes(this.detail.status) && this.$is() === 'provider') {
        total = this.table.data.reduce((acc, product) => {
          product.total = this.calculatePriceProductWithTaxes(product) * product.quantityConfirmed
          acc += product.total
          return acc
        }, 0)
      }
      if (this.detail.status === 'invoiced') {
        total = this.table.data.reduce((acc, product) => {
          product.total = this.calculatePriceProductWithTaxes(product) * product.quantityReceived
          acc += product.total
          return acc
        }, 0)
      }
      this.detail.total = total
    },
    calculateCommission (total) {
      const feeRate = (this.restaurant.fees.purchaseOrder / 100) * 1.16
      return total * feeRate
    },
    closeDialog () {
      this.isModificated = false
      this.$emit('close')
    },
    updateTable: async function (data) {
      const { sortBy, sortDesc } = data
      if (this.order.id) {
        await this.load({
          limit: data.itemsPerPage,
          skip: (data.itemsPerPage * (data.page - 1)),
          sort: `${sortDesc[0] ? '-' : ''}${sortBy[0]}`
        })
      }
    },
    async load (params = null) {
      this.overlay = true
      params = params || {
        limit: this.table.options.itemsPerPage,
        skip: (this.table.options.itemsPerPage * (this.table.options.page - 1))
      }
      try {
        const { response } = await this.orderModel.detail({ params })
        this.table.loading = false
        response.data.products.map((element, index) => { element.number = index + 1 })
        this.detail = response.data
        this.table.data = this.getProductsPricesWithTaxes(response.data.products)
        this.table.total = response.data.products.length
        if (response.data.originalProducts) {
          response.data.originalProducts.map((element, index) => { element.number = index + 1 })
          this.tableOriginalProducts.data = this.getProductsPricesWithTaxes(response.data.originalProducts)
          this.tableOriginalProducts.total = response.data.products.length
        }
        this.$emit('update')
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
      this.table.loading = false
    },
    getProductsPricesWithTaxes (products) {
      return ['provider'].includes(this.$is()) && ['sent', 'confirmed'].includes(this.detail.status)
        ? products.map(product => {
          let priceWithTaxes = product.amount

          if (product.taxes.length) {
            priceWithTaxes = this.calculatePriceProductWithTaxes(product)
          }

          const unitAmountWithTaxes = priceWithTaxes
          const iva = product.taxes.find(tax => tax.satCode === '002' && tax.base > 0)
          const ieps = this.findIEPS(product.taxes)
          const iepsAmount = ieps ? (ieps.isQuota ? ieps.base : ieps.base / 100) * (product.amount - (product.discount || 0)) : 0
          return Object.assign(
            {},
            product,
            {
              ieps: iepsAmount,
              iva: iva ? (iva.base / 100) * (product.amount + iepsAmount) : 0,
              unitAmountWithTaxes,
              total: unitAmountWithTaxes * product.quantityConfirmed
            }
          )
        })
        : products
    },
    calculatePriceProductWithTaxes (product) {
      let priceWithTaxes = product.amount
      const hasBaseAmount = (product.taxes || []).every(tax => tax.baseAmount && tax.baseAmount >= 0)

      if (hasBaseAmount) {
        const taxesAmount = product.taxes.reduce((acc, tax) => {
          const base = tax.isQuota ? tax.base : (tax.base / 100)
          return acc + (tax.baseAmount * base)
        }, 0)
        return priceWithTaxes + taxesAmount
      } else {
        let totalTaxes = 0
        const ieps = this.findIEPS(product.taxes)
        const iva = product.taxes.find(tax => tax.satCode === '002' && tax.base > 0)
        const otherTaxes = product.taxes
          .filter(tax => !['003', '002'].includes(tax.satCode))

        if (ieps) {
          const iepsAmount = (ieps.isQuota ? ieps.base : ieps.base / 100) * (product.amount - (product.discount || 0))
          priceWithTaxes = priceWithTaxes + iepsAmount
        }

        totalTaxes = otherTaxes.reduce((acc, num) => {
          let taxApplied
          if (num.isQuota) {
            taxApplied = num.base
          } else {
            taxApplied = (num.base / 100) * product.amount
          }
          acc += taxApplied
          return acc
        }, 0)

        if (iva) {
          priceWithTaxes = priceWithTaxes + (priceWithTaxes * (iva.base / 100))
        }

        priceWithTaxes = totalTaxes + priceWithTaxes

        return priceWithTaxes
      }
    },
    convertToDateString (date) {
      const d = new Date(date)
      return d.toLocaleDateString()
    },
    send: async function (data) {
      this.overlay = true
      const payload = {
        restaurant: this.detail.restaurant,
        notes: this.notes,
        deliveryAddress: this.deliveryAddress,
        items: this.table.data.map(prod => {
          return { id: prod._id, quantity: prod.quantityConfirmed, amount: prod.amount }
        })
      }
      try {
        const { response } = await this.orderModel.send(payload)
        this.detail = response.data
        this.cancelDialog = false
        this.$emit('update')
      } catch (error) {
        this.$toasted.show(error.response.response.data.message, { duration: 3000 })
      }
      this.overlay = false
    },
    cancel: async function (data) {
      this.overlay = true
      if (this.selectedReason === 'other') this.selectedReason = this.otherMotive
      const payload = {
        restaurant: this.detail.restaurant._id || this.detail.restaurant,
        cancelationMotive: this.selectedReason
      }
      try {
        const { response } = await this.orderModel.cancel(payload)
        this.detail = response.data
        this.cancelDialog = false
        this.$emit('update')
        this.selectedReason = ''
        this.otherMotive = ''
        this.closeDialog()
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    refund: async function (data) {
      this.overlay = true
      const payload = {
        restaurant: this.detail.restaurant,
        cancelInvoice: this.forceCancelInvoice
      }
      try {
        const { response } = await this.orderModel.refund(payload)
        this.detail = response.data
        this.detail.status = 'canceled'
        this.refundDialog = false
        this.forceCancelInvoice = false
        this.$emit('update')
        this.closeDialog()
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    localConfirm: async function () {
      this.overlay = true
      try {
        const payload = {
          items: this.table.data.map(prod => ({
            id: prod._id,
            quantity: prod.quantityConfirmed
          }))
        }
        const { response } = await this.orderModel.localConfirm(payload)
        this.detail = response.data
        this.$emit('update')
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    pay: async function () {
      this.overlay = true
      try {
        const { response } = await this.orderModel.pay()
        this.detail = response.data
        this.$emit('update')
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    read: async function () {
      this.overlay = true
      try {
        const { response } = await this.orderModel.update({ isRead: true, restaurant: this.detail.restaurant._id })
        this.detail = response.data
        this.$emit('update')
        this.closeDialog()
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    saveChanges: async function () {
      this.overlay = true

      const payload = {
        restaurant: this.detail.restaurant._id || this.detail.restaurant,
        items: this.table.data.map(prod => {
          return {
            id: prod._id,
            quantity: prod.quantityConfirmed,
            amount: prod.amount,
            taxes: prod.taxes
          }
        })
      }

      try {
        const { response } = await this.orderModel.update(payload)
        this.detail = response.data
        this.$emit('update')
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    confirm: async function (propagate) {
      this.overlay = true

      const payload = {
        restaurant: this.detail.restaurant._id,
        items: this.table.data.map(prod => {
          return {
            id: prod._id,
            quantity: prod.quantityConfirmed,
            amount: prod.amount,
            taxes: prod.taxes
          }
        })
      }
      const services = this.servicesTable.data.map(serv => {
        return { id: serv.product.id, quantity: 1, amount: serv.amount }
      })
      let prices = []
      for (const product of this.table.data) {
        prices.push({ amount: product.amount, id: product.choice, product: product.product, contentUnit: product.contentUnit })
      }
      payload.propagate = propagate
      payload.prices = prices
      payload.items = payload.items.concat(services)
      try {
        const { response } = await this.orderModel.confirm(payload)
        this.detail = response.data
        this.$emit('update')
        this.isModificated = false
        this.onClosePropagateDialog()
        this.closeDialog()
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    receive: async function () {
      this.overlay = true
      const payload = {
        restaurant: this.detail.restaurant,
        items: this.table.data.map(prod => {
          return { id: prod._id, quantity: prod.quantityReceived, amount: prod.amount }
        })
      }
      try {
        const { response } = await this.orderModel.receive(payload)
        this.detail = response.data.order
        this.productsToInventory.data = response.data.productsToInventory
        this.$emit('update')
        if (this.productsToInventory.data.length) this.showProductsToInventory = true
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    onRefundOrderDialog: function () {
      this.refundDialog = true
    },
    onCloseRefundOrderDialog: function () {
      this.forceCancelInvoice = false
      this.refundDialog = false
    },
    onCancelOrderDialog: function () {
      this.cancelDialog = true
    },
    onCloseCancelOrderDialog: function () {
      this.selectedReason = ''
      this.otherMotive = ''
      this.cancelDialog = false
    },
    uploadInvoice: async function (order) {
      this.billDialog = true
    },
    closeBillDialog: async function () {
      await this.load()
      this.billDialog = false
      this.$emit('update', new Order(this.detail))
    },
    openRemoveDialog (item) {
      this.removeDialog = true
      this.itemToRemove = item
    },
    onCloseRemoveDialog () {
      this.removeDialog = false
      this.itemToRemove = {}
    },
    async removeProduct () {
      this.overlay = true
      const payload = {
        restaurant: this.detail.restaurant,
        items: this.table.data
          .filter(prod => prod.id !== this.itemToRemove.id)
          .map(prod => {
            return { id: prod._id, quantity: prod.quantityRequested, amount: prod.amount }
          })
      }
      try {
        const { response } = await this.orderModel.update(payload)
        this.detail = response.data
        if (response.data.products.length > 0) {
          this.$emit('update')
        } else {
          this.$emit('remove')
        }

        this.closeDialog()
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.onCloseRemoveDialog()
      this.overlay = false
    },
    resetDeliverDialog () {
      this.deliverForm = {
        nip: null
      }
      this.agreeDeliver = null
      this.$refs.nip.resetValidation()
    },
    onDeliverDialog () {
      this.deliverDialog = true
    },
    onPropagateDialog () {
      this.confirm(false)
      // if (this.isModificated) {
      //   this.propagateDialog = true
      // } else {
      // }
    },
    onClosePropagateDialog () {
      this.propagateDialog = false
    },
    onCloseDeliverDialog () {
      this.deliverDialog = false
      this.resetDeliverDialog()
    },
    async deliver () {
      const isValid = this.$refs.nip.validate()
      if (isValid) {
        this.overlay = true
        try {
          const payload = this.deliverForm
          const { response } = await this.orderModel.receiveWithCode(payload)
          this.detail = response.data
          this.$emit('update')
          this.onCloseDeliverDialog()
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
        this.overlay = false
      }
    },
    async issueNewInvoice (invoice) {
      const payload = {
        text: `Se solicitó que se vuelva a generar la factura ${invoice.folio} para la orden ${this.order.uuid}`,
        order: this.order.id,
        provider: this.order.provider._id,
        type: 'Solicitud de nueva factura'
      }
      this.overlay = true
      try {
        await this.$api.post(`/v1/issue`, payload)
        this.$toasted.show('Solicitud enviada', { duration: 3000 })
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    async receiveWithoutInvoice () {
      this.overlay = true
      const payload = {
        restaurant: this.detail.restaurant,
        items: this.table.data.map(prod => {
          return { id: prod._id, quantity: prod.quantityReceived, amount: prod.amount }
        })
      }
      try {
        const { response } = await this.orderModel.receiveWithoutInvoice(payload)
        this.detail = response.data
        this.$emit('update')
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    async attachInvoice () {
      this.attachDialog = true
    },
    async closeAttachDialog () {
      await this.load()
      this.attachDialog = false
      this.$emit('update')
    },
    async reSentPurchaseOrderEmail () {
      this.overlay = true
      try {
        await this.$api.post(`/v1/orders/${this.detail._id}/re-sent-notification`)
        this.$toasted.show('Se ha enviado el correo exitosamente.', { duration: 3500, type: 'success', position: 'top-center', iconPack: 'mdi', icon: 'mdi-check-circle' })
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3500, type: 'error', position: 'top-center', iconPack: 'mdi', icon: 'mdi-cancel' })
      }
      this.overlay = false
    },
    printOrder () {
      const copyTable = this.table.data
      copyTable.map(function (item) {
        if (item.choice) {
          item.choice.brand = item.choice.brand || ''
          item.choice.description = item.choice.description || ''
        }
        return item
      })
      const printableJson = copyTable

      print({
        printable: printableJson,
        properties: [
          { field: 'number', displayName: '' },
          { field: 'name', displayName: 'Producto' },
          { field: 'choice.description', displayName: 'Descripción' },
          { field: 'choice.brand', displayName: 'Marca' },
          { field: 'quantityRequested', displayName: 'Cantidad solicitada' },
          { field: 'amountWithTax', displayName: 'Precio unitario' },
          { field: 'totalWithTax', displayName: 'Total' }
        ],
        type: 'json',
        header: `<div>Orden: ${this.detail.uuid}</div><div>Total: $${this.total}</div>`
      })
    },
    openEditDialog () {
      const order = cloneDeep()
      this.selectedRecipe = order
      this.$refs.editDialog.open()
    },
    emitUpdate () {
      this.$emit('update', new Order(this.detail))
    },
    openEditVariantInOrder (product) {
      this.$refs.editVariantInOrder.open(this.detail, product)
    },
    openCheckStatusInvoice (invoice, data) {
      this.$refs.checkStatusInvoice.open(invoice, data)
    },
    displayModificationText (order) {
      let text = '-'
      if (order.status === 'created') text = 'Creada por : '
      if (order.status === 'sent') text = 'Enviada por : '
      if (order.status === 'confirmed') text = 'Confirmada por : '
      if (order.status === 'invoiced') text = 'Facturada por : '
      if (order.status === 'invalid') text = 'Última modificación por : '
      if (['received', 'pending_payment', 'paid'].includes(this.detail.status)) text = 'Recibida por : '
      if (order.status === 'canceled') text = 'Cancelada por : '
      return text
    },
    getLastModificationPerson () {
      if (this.detail.status === 'created') {
        return this.detail.author.email
      } else if (this.detail.statusChanges) {
        const statusChanges = this.detail.statusChanges.find(x => x.name === this.detail.status)
        if (statusChanges && statusChanges.updateBy && statusChanges.updateBy.email) {
          return statusChanges.updateBy.email
        }
      }
      return '-'
    },
    findCancelationMotive (motive) {
      const motives = ['wrong_provider_product', 'product_not_received', 'shortage', 'product_not_neeed_it', 'restaurant_cancelation', 'wrong_quantity_or_product', 'restaurant_is_not_a_client', 'out_delivery_zone_range']
      if (!motives.includes(motive)) return motive
      return {
        wrong_provider_product: 'Me equivoqué en proveedor / producto',
        product_not_received: 'No recibí el producto',
        shortage: 'Desabasto',
        product_not_neeed_it: 'Ya no necesito el producto',
        restaurant_cancelation: 'Solicité una cancelación',
        wrong_quantity_or_product: 'Hay un error en el pedido: cantidades y/o producto',
        restaurant_is_not_a_client: 'No eres cliente del proveedor',
        out_delivery_zone_range: 'Tu zona está fuera del rango de entregas del proveedor'
      }[motive]
    }
  }
}
</script>

<style lang="scss">

.v-application--is-ltr .v-list-group--no-action > .v-list-group__items > div > .v-list-item {
    padding-left: 0px;
}

.v-tooltip__content {
  line-height: 18px;
  width: 340px;
}

.v-timeline-item__body {
  max-width: 90px;
}
</style>
